﻿
const SELECTORS = {
    clearAllFieldsButton: '.js-clear-all-fields-button'
}

const URLS = {
    createRateUrl: window.createRateUrl || '/quote', // Fallback URL
}

export function toggleModalVisibility(modalOrSelector, state) {
    const modal = modalOrSelector instanceof Element
        ? modalOrSelector
        : document.querySelector(modalOrSelector);
    
    if (modal) {
        modal.style.display = state ? 'block' : 'none';
    } else {
        console.error("Modal not found!");
    }
}

export function initCloseModalsEventListeners(fixForCustomDropDown) {
    var closeModalIcon = document.querySelectorAll('.js-close-modal');
    for (var i = 0; i < closeModalIcon.length; i++) {
        closeModalIcon[i].addEventListener('click', function (e) {
            if (fixForCustomDropDown) {
                e.stopPropagation();
            }
            // jQuery for IE
            $(this).closest('.modal')[0].style.display = 'none';

        }, false);
    }
};

const clearAllFields = () => {
    window.location.href = URLS.createRateUrl;
}

export const initializeModalsEventListeners = () => {
    const clearAllFieldsButtons = document.querySelectorAll(SELECTORS.clearAllFieldsButton);

    if (clearAllFieldsButtons.length > 0) {
        clearAllFieldsButtons.forEach(button => {
            button.addEventListener('click', function (e) {
                e.preventDefault();
                clearAllFields();
            }, false);
        })
    }
}